import { render, staticRenderFns } from "./WhoWeAre.vue?vue&type=template&id=3f46f742&scoped=true"
import script from "./WhoWeAre.vue?vue&type=script&lang=js"
export * from "./WhoWeAre.vue?vue&type=script&lang=js"
import style0 from "./WhoWeAre.vue?vue&type=style&index=0&id=3f46f742&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f46f742",
  null
  
)

export default component.exports